export default "__VITE_ASSET__hsWxRk05__";